import {
  FETCH_USERS,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  SHOW_USER_SETTINGS_FORM_FOR_ADD,
  SHOW_USER_SETTINGS_FORM_FOR_EDIT,
  HIDE_USER_SETTINGS_FORM_FOR_ADD,
  HIDE_USER_SETTINGS_FORM_FOR_EDIT,
  FETCH_INITIAL_DATA_FOR_USER_SETTINGS,
  FETCH_INITIAL_DATA_FOR_USER_SETTINGS_SUCCESS,
  FETCH_INITIAL_DATA_FOR_USER_SETTINGS_FORM,
  FETCH_INITIAL_DATA_FOR_USER_SETTINGS_FORM_SUCCESS,
  FETCH_LOGGED_IN_USER_SETTINGS_SUCCESS,
  RESET_USER_TO_EDIT,
  SAVING_USER_SETTINGS,
  SAVING_USER_SETTINGS_SUCCESS,
  SAVING_USER_SETTINGS_FAILURE,
  DISABLE_READ_ONLY_MODE,
  SET_USER_MODIFIED,
  CHECK_IF_USER_SSO_EXISTS,
  CHECK_IF_USER_SSO_EXISTS_SUCCESS,
  CHECK_IF_USER_SSO_EXISTS_FAILURE,
  CHECK_IF_USER_EMAIL_EXISTS,
  CHECK_IF_USER_EMAIL_EXISTS_SUCCESS,
  CHECK_IF_USER_EMAIL_EXISTS_FAILURE,
  CHECK_IF_USER_PWC_EMAIL_SETUP,
  CHECK_IF_USER_PWC_EMAIL_SETUP_SUCCESS,
  CHECK_IF_USER_PWC_EMAIL_SETUP_FAILURE,
  CHECK_IF_USER_EMAIL_IS_UNDER_DOMAIN,
  CHECK_IF_USER_EMAIL_IS_UNDER_DOMAIN_SUCCESS,
  CHECK_IF_USER_EMAIL_IS_UNDER_DOMAIN_FAILURE,
  FETCH_ROLE_ASSIGNMENTS,
  FETCH_ROLE_ASSIGNMENTS_SUCCESS,
  FETCH_ROLE_ASSIGNMENTS_FAILURE,
  FETCH_INITIAL_DATA_FOR_USER_SETTINGS_FORM_FAILURE,
  FETCH_EXPIRATION_DATE_PRIVILEGE,
  FETCH_EXPIRATION_DATE_PRIVILEGE_SUCCESS,
  FETCH_EXPIRATION_DATE_PRIVILEGE_FAILURE,
} from './types';

import initialState from './initialState';

function usersReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_USERS:
      return {
        ...state,
        isLoadingUsers: true,
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
        isLoadingUsers: false,
      };
    case FETCH_USERS_FAILURE:
      return {
        ...state,
        isLoadingUsers: false,
      };
    case SHOW_USER_SETTINGS_FORM_FOR_ADD:
      return {
        ...state,
        openFormForAdd: true,
        openFormForEdit: false,
        readOnly: false,
        isUserModified: false,
      };
    case HIDE_USER_SETTINGS_FORM_FOR_ADD:
      return {
        ...state,
        openFormForAdd: false,
      };
    case SHOW_USER_SETTINGS_FORM_FOR_EDIT:
      return {
        ...state,
        openFormForEdit: true,
        openFormForAdd: false,
        userToEditSso: action.userToEditSso,
        readOnly: action.readOnly,
        isUserModified: false,
      };
    case HIDE_USER_SETTINGS_FORM_FOR_EDIT:
      return {
        ...state,
        openFormForEdit: false,
      };
    case FETCH_INITIAL_DATA_FOR_USER_SETTINGS_FORM:
      return {
        ...state,
        isFetchingInitialDataForUserSettingsForm: true,
      };
    case FETCH_INITIAL_DATA_FOR_USER_SETTINGS_FORM_FAILURE:
      return {
        ...state,
        isFetchingInitialDataForUserSettingsForm: false,
      };
    case FETCH_INITIAL_DATA_FOR_USER_SETTINGS_FORM_SUCCESS:
    {
      return {
        ...state,
        isFetchingInitialDataForUserSettingsForm: false,
        userToEdit: action.userToEdit || null,
        userToEditPrivileges: action.userToEditPrivileges || null,
      };
    }
    case FETCH_LOGGED_IN_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        loggedInUser: action.userSettings,
      };
    case FETCH_INITIAL_DATA_FOR_USER_SETTINGS:
      return {
        ...state,
        isFetchingInitialDataForUserSettings: true,
      };
    case FETCH_INITIAL_DATA_FOR_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        isFetchingInitialDataForUserSettings: false,
        userSettingsFormData: action.userSettingsFormData,
      };
    case RESET_USER_TO_EDIT:
      return {
        ...state,
        userToEditSso: initialState.userToEditSso,
        userToEdit: initialState.userToEdit,
        openFormForAdd: false,
        openFormForEdit: false,
      };
    case SAVING_USER_SETTINGS:
      return {
        ...state,
        isSavingInProgress: true,
      };
    case SAVING_USER_SETTINGS_SUCCESS:
    case SAVING_USER_SETTINGS_FAILURE:
      return {
        ...state,
        isSavingInProgress: false,
      };
    case DISABLE_READ_ONLY_MODE:
      return {
        ...state,
        readOnly: false,
      };
    case SET_USER_MODIFIED:
      return {
        ...state,
        isUserModified: action.isUserModified,
      };
    case CHECK_IF_USER_EMAIL_EXISTS:
      return {
        ...state,
        isCheckingIfUsersEmailExists: true,
        isEmailUnique: initialState.isEmailUnique,
      };
    case CHECK_IF_USER_EMAIL_EXISTS_SUCCESS:
      return {
        ...state,
        isCheckingIfUsersEmailExists: false,
        isEmailUnique: action.isEmailUnique,
      };
    case CHECK_IF_USER_EMAIL_EXISTS_FAILURE:
      return {
        ...state,
        isCheckingIfUsersEmailExists: false,
      };
    case CHECK_IF_USER_PWC_EMAIL_SETUP:
      return {
        ...state,
        isPwcEmailSetup: initialState.isPwcEmailSetup,
      };
    case CHECK_IF_USER_PWC_EMAIL_SETUP_SUCCESS:
      return {
        ...state,
        isPwcEmailSetup: action.isPwcEmailSetup,
      };
    case CHECK_IF_USER_PWC_EMAIL_SETUP_FAILURE:
      return {
        ...state,
      };
    case CHECK_IF_USER_EMAIL_IS_UNDER_DOMAIN:
      return {
        ...state,
        isCheckingIfUserEmailIsUnderDomain: true,
        isUserEmailUnderDomain: initialState.isUserEmailUnderDomain,
      };
    case CHECK_IF_USER_EMAIL_IS_UNDER_DOMAIN_SUCCESS:
      return {
        ...state,
        isCheckingIfUserEmailIsUnderDomain: false,
        isUserEmailUnderDomain: action.isUserEmailUnderDomain,
      };
    case CHECK_IF_USER_EMAIL_IS_UNDER_DOMAIN_FAILURE:
      return {
        ...state,
        isCheckingIfUserEmailIsUnderDomain: false,
      };
    case CHECK_IF_USER_SSO_EXISTS:
      return {
        ...state,
        isCheckingIfUsersSSOExists: true,
        isSSOUnique: initialState.isSSOUnique,
      };
    case CHECK_IF_USER_SSO_EXISTS_SUCCESS:
      return {
        ...state,
        isCheckingIfUsersSSOExists: false,
        isSSOUnique: action.isSSOUnique,
      };
    case CHECK_IF_USER_SSO_EXISTS_FAILURE:
      return {
        ...state,
        isCheckingIfUsersSSOExists: false,
      };
    case FETCH_ROLE_ASSIGNMENTS:
      return {
        ...state,
        loadingRolesAssignmentsCount: state.loadingRolesAssignmentsCount + 1,
      };
    case FETCH_ROLE_ASSIGNMENTS_SUCCESS: {
      return {
        ...state,
        loadingRolesAssignmentsCount: state.loadingRolesAssignmentsCount - 1,
        rolesAssignmentsMaps: {
          ...state.rolesAssignmentsMaps,
          [action.roleId]: action.roleAssignmentsMaps,
        },
        rolesAssignments: {
          ...state.rolesAssignments,
          [action.roleId]: action.roleAssignments,
        },
      };
    }
    case FETCH_ROLE_ASSIGNMENTS_FAILURE: {
      return {
        ...state,
        loadingRolesAssignmentsCount: state.loadingRolesAssignmentsCount - 1,
      };
    }
    case FETCH_EXPIRATION_DATE_PRIVILEGE:
      return {
        ...state,
        loadingExpirationDatePrivilege: true,
      };
    case FETCH_EXPIRATION_DATE_PRIVILEGE_SUCCESS:
      return {
        ...state,
        isExpirationDatePrivilege: action.isExpirationDatePrivilege,
      };
    case FETCH_EXPIRATION_DATE_PRIVILEGE_FAILURE:
      return {
        ...state,
        loadingExpirationDatePrivilege: false,
      };
    default:
      return state;
  }
}

export default usersReducer;
